import { JourneyButton } from '@ahmdigital/ui';
import styled from 'styled-components';

import AccordionSection from '../../../../../../components/sections/accordion-section';

export const StyledAccordionSection = styled(AccordionSection)`
  padding: 0;

  & > section:last-of-type {
    border-bottom: none;
  }
`;

export const ServiceWrapper = styled.div`
  margin: 0;

  & > section {
    padding: unset;

    header > button > p {
      font-weight: normal;
    }
  }
`;

export const DestinationContainer = styled.div`
  margin-bottom: 1.5rem;
  grid-template-columns: repeat(2, 1fr);
  display: grid;
  gap: 0.5rem;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const StyledJourneyButton = styled(JourneyButton)`
  padding: 0 0.5rem;
  text-align: center;

  &:hover {
    padding: 0 0.5rem;
  }
`;

export const ContentWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.media.md}) {
    width: 34.5rem;
  }
`;
